import { User } from '../types';
import { apiClient } from './api/axios';
import { API_CONFIG } from '../config/api';

interface LoginResponse {
  user: User;
  token: string;
  refreshToken: string;
}

interface RegisterResponse {
  user: User;
  token: string;
  refreshToken: string;
}

// Mock data for development
const mockUser: User = {
  id: '1',
  name: 'Demo User',
  email: 'demo@example.com',
  created_at: new Date().toISOString()
};

export class AuthService {
  
  static async checkEmailExists(email: string): Promise<boolean> {
    try {
      // Use the correct base URL for your environment
      const baseUrl = API_CONFIG.BASE_URL.development;
      const url = `${baseUrl}${API_CONFIG.ENDPOINTS.AUTH.CHECK_EMAIL}?email=${encodeURIComponent(email)}`;
      const response = await apiClient.get<{ exists: boolean }>(url);
      return response.exists;
    } catch (error) {
      // Optionally handle error (e.g., network error)
      return false;
    }
  }

  static async register(name: string, email: string, password: string): Promise<RegisterResponse> {
    try {
      const response = await apiClient.post<RegisterResponse>(API_CONFIG.ENDPOINTS.AUTH.REGISTER, {
        name,
        email,
        password,
      }, { withCredentials: true }); // Ensure credentials (cookies) are sent with the request
  
      const { user, token, refreshToken } = response;
  
      // Cookies will automatically be managed by the browser, no need for localStorage
  
      return { user, token, refreshToken };
    } catch (error) {
      throw new Error('Registration failed');
    }
  }
  
  static async login(email: string, password: string): Promise<LoginResponse> {
    try {
      const response = await apiClient.post<LoginResponse>(API_CONFIG.ENDPOINTS.AUTH.LOGIN, {
        email,
        password,
      }, { withCredentials: true }); // Ensure credentials (cookies) are sent with the request
  
      const { user, token, refreshToken } = response;
  
      // Cookies will automatically be managed by the browser, no need for localStorage
  
      return { user, token, refreshToken };
    } catch (error) {
      throw new Error('Login failed');
    }
  }
  
  // Reset password request
  static async resetPassword(email: string): Promise<void> {
    // Mock implementation
  }

  // Confirm password reset
  static async confirmResetPassword(token: string, newPassword: string): Promise<void> {
    // Mock implementation
  }

  // Update user profile
  static async updateProfile(userId: string, data: Partial<User>): Promise<User> {
    // Mock implementation
    return { ...mockUser, ...data };
  }

  // Change password
  static async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    // Mock implementation
  }

 
 // Logout
static async logout(): Promise<void> {
  try {
    await apiClient.post(API_CONFIG.ENDPOINTS.AUTH.LOGOUT, {}, { withCredentials: true });
  } catch (error) {
    console.error('Logout failed:', error);
    throw new Error('Logout failed');
  }
}
}